export const navigationComponentConfig = {
  components: [],
};
